var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _rect2, _path8, _path9, _path10, _rect3, _path11, _path12, _rect4, _path13, _rect5, _path14, _rect6, _path15, _rect7, _line, _path16, _line2, _path17, _line3, _path18, _line4, _path19, _line5, _path20, _rect8, _path21, _path22, _rect9, _path23, _rect10, _path24, _circle, _path25, _circle2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle3, _circle4, _path38, _path39, _path40, _path41, _polyline, _path42, _rect11, _path43, _path44, _path45, _path46, _line6, _path47, _line7, _path48, _circle5, _path49, _rect12, _path50, _circle6, _path51, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_110_report_analysis",
    "data-name": "#110_report_analysis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.76,120l1.81,33.44-47.51,2.33-29.74-1.73s5.57-32.94,8.67-35.47S235.76,120,235.76,120Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.08,156.28l-29.79-1.73a.49.49,0,0,1-.36-.18.54.54,0,0,1-.11-.4c.58-3.39,5.7-33.21,8.86-35.78s60.58.91,67.11,1.32a.49.49,0,0,1,.47.47l1.81,33.45a.49.49,0,0,1-.13.36.46.46,0,0,1-.35.16Zm-29.18-2.69,29.19,1.69L237,153l-1.75-32.5c-25.52-1.58-63.82-3.27-66-1.52S163.15,140.41,160.9,153.59Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.17,135.36a389.61,389.61,0,0,0,205.66,0l28.95,105.8a499.41,499.41,0,0,1-263.56,0Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200,259.35a500.12,500.12,0,0,1-131.91-17.7.48.48,0,0,1-.3-.24.46.46,0,0,1-.05-.38l28.94-105.8a.51.51,0,0,1,.62-.35,389.46,389.46,0,0,0,205.4,0,.51.51,0,0,1,.62.35L332.26,241a.46.46,0,0,1-.05.38.48.48,0,0,1-.3.24A500.12,500.12,0,0,1,200,259.35ZM68.84,240.81a499.09,499.09,0,0,0,262.32,0L302.48,136a390.48,390.48,0,0,1-205,0Z",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.72,129.3a2,2,0,0,1-1.62-3.18c7.31-10,15.24-22.19,15.53-24.8-.8-1.84-8.33-7.64-15-12A2,2,0,1,1,131.81,86c14.15,9.23,16.42,13.19,16.74,14.47.9,3.63-8.32,17.25-16.22,28A2,2,0,0,1,130.72,129.3Zm13.92-28.08Z",
    fill: "#231f20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.03,
    y: 83.2,
    width: 14.36,
    height: 55.05,
    rx: 7.18,
    transform: "translate(256.43 221.45) rotate(-180)",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.21,138.75a7.7,7.7,0,0,1-7.68-7.69V90.38a7.69,7.69,0,0,1,15.37,0v40.68A7.7,7.7,0,0,1,128.21,138.75Zm0-55a6.69,6.69,0,0,0-6.68,6.68v40.68a6.69,6.69,0,1,0,13.37,0V90.38A6.69,6.69,0,0,0,128.21,83.7Z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.28,129.3a2,2,0,0,1-1.61-.82c-7.9-10.79-17.12-24.41-16.22-28,.32-1.28,2.59-5.24,16.74-14.47a2,2,0,0,1,2.19,3.35c-6.67,4.35-14.17,10.13-15,12,.3,2.62,8.22,14.82,15.53,24.8a2,2,0,0,1-1.62,3.18Zm-13.92-28.08Z",
    fill: "#231f20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 264.6,
    y: 83.2,
    width: 14.36,
    height: 55.05,
    rx: 7.18,
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.79,138.75a7.7,7.7,0,0,1-7.69-7.69V90.38a7.69,7.69,0,0,1,15.37,0v40.68A7.7,7.7,0,0,1,271.79,138.75Zm0-55a6.69,6.69,0,0,0-6.69,6.68v40.68a6.69,6.69,0,1,0,13.37,0V90.38A6.69,6.69,0,0,0,271.79,83.7Z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.12,41.14h91.76c7.66,0,13.65,5.79,12.9,12.48L252.72,108H147.28l-6.06-54.35C140.47,46.93,146.46,41.14,154.12,41.14Z",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.72,108.47H147.28a.5.5,0,0,1-.5-.44l-6.06-54.35a10.86,10.86,0,0,1,2.83-8.52,14.08,14.08,0,0,1,10.57-4.52h91.76a14.08,14.08,0,0,1,10.57,4.52,10.86,10.86,0,0,1,2.83,8.52L253.22,108A.5.5,0,0,1,252.72,108.47Zm-105-1H252.28l6-53.9a9.88,9.88,0,0,0-2.58-7.74,13.1,13.1,0,0,0-9.83-4.19H154.12a13.1,13.1,0,0,0-9.83,4.19,9.88,9.88,0,0,0-2.58,7.74Z",
    fill: "#231f20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 152.73,
    y: 164.57,
    width: 112.21,
    height: 73.23,
    transform: "translate(434.78 382.95) rotate(174.88)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.22,243.16a.49.49,0,0,1-.5-.45l-6.53-72.94a.53.53,0,0,1,.11-.37.52.52,0,0,1,.34-.18l111.76-10a.5.5,0,0,1,.55.45l6.53,72.94a.5.5,0,0,1-.12.37.47.47,0,0,1-.34.17l-111.76,10Zm-6-73,6.44,72,110.77-9.92L261,160.26Z",
    fill: "#d1d3d4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.12,50.67H147.88a.5.5,0,1,1,0-1H252.12a.5.5,0,1,1,0,1Z",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 135.88,
    y: 155.78,
    width: 110.06,
    height: 68.33,
    transform: "translate(381.81 379.88) rotate(180)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.94,224.6H135.88a.5.5,0,0,1-.5-.5V155.78a.5.5,0,0,1,.5-.5H245.94a.5.5,0,0,1,.5.5V224.1A.5.5,0,0,1,245.94,224.6Zm-109.56-1H245.44V156.28H136.38Z",
    fill: "#231f20"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.96,
    y: 184.14,
    width: 12.97,
    height: 12.97,
    transform: "translate(464.89 381.26) rotate(180)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.93,197.61H226a.5.5,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v13A.5.5,0,0,1,238.93,197.61Zm-12.47-1h12v-12h-12Z",
    fill: "#d1d3d4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 204.77,
    y: 184.14,
    width: 12.97,
    height: 23.99,
    transform: "translate(422.5 392.28) rotate(180)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.74,208.64h-13a.5.5,0,0,1-.5-.5v-24a.5.5,0,0,1,.5-.5h13a.51.51,0,0,1,.5.5v24A.51.51,0,0,1,217.74,208.64Zm-12.47-1h12v-23h-12Z",
    fill: "#d1d3d4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 183.58,
    y: 184.14,
    width: 12.97,
    height: 33.5,
    transform: "translate(380.12 401.79) rotate(180)",
    fill: "#FF663B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 173.53,
    y1: 210.62,
    x2: 147.11,
    y2: 210.62,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53,211.12H147.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h26.42a.51.51,0,0,1,.5.5A.5.5,0,0,1,173.53,211.12Z",
    fill: "#d1d3d4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 173.53,
    y1: 203.38,
    x2: 147.11,
    y2: 203.38,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53,203.88H147.11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h26.42a.51.51,0,0,1,.5.5A.5.5,0,0,1,173.53,203.88Z",
    fill: "#d1d3d4"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 173.53,
    y1: 196.14,
    x2: 153.92,
    y2: 196.14,
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53,196.64H153.92a.5.5,0,1,1,0-1h19.61a.5.5,0,0,1,0,1Z",
    fill: "#d1d3d4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 237.95,
    y1: 172.85,
    x2: 184.9,
    y2: 172.85,
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238,173.35h-53a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h53a.5.5,0,0,1,.5.5A.5.5,0,0,1,238,173.35Z",
    fill: "#d1d3d4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 237.95,
    y1: 165.83,
    x2: 194.53,
    y2: 165.83,
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238,166.33H194.53a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H238a.5.5,0,0,1,.5.5A.5.5,0,0,1,238,166.33Z",
    fill: "#d1d3d4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 145.73,
    y: 162.41,
    width: 17.55,
    height: 25.14,
    transform: "translate(309 349.95) rotate(180)",
    fill: "#d1d3d4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,164h3.7a0,0,0,0,1,0,0v13.81a1.74,1.74,0,0,1-1.74,1.74h-.21a1.74,1.74,0,0,1-1.74-1.74V164A0,0,0,0,1,170.54,164Z",
    transform: "translate(402.75 250.19) rotate(153.91)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M174.15,180.05a.49.49,0,0,1-.45-.28l-6.08-12.4a2.23,2.23,0,0,1-.1-1.72,2.19,2.19,0,0,1,1.13-1.28l.19-.1a2.25,2.25,0,0,1,3,1l6.08,12.41a.46.46,0,0,1,0,.38.51.51,0,0,1-.25.29L174.37,180A.44.44,0,0,1,174.15,180.05Zm-4.32-15a1.2,1.2,0,0,0-.55.13l-.19.09h0a1.24,1.24,0,0,0-.63.72,1.3,1.3,0,0,0,.06,1l5.86,11.95,2.42-1.18-5.85-12A1.26,1.26,0,0,0,169.83,165Zm-1-.22h0Z",
    fill: "#231f20"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 175.28,
    y: 177.01,
    width: 5.97,
    height: 13.51,
    transform: "translate(419.19 270.4) rotate(153.91)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.56,191.64l-.16,0a.53.53,0,0,1-.29-.26l-5.94-12.13a.5.5,0,0,1,.23-.67l5.36-2.63a.46.46,0,0,1,.38,0,.48.48,0,0,1,.29.25l5.94,12.14a.51.51,0,0,1-.23.67l-5.36,2.62A.59.59,0,0,1,178.56,191.64Zm-5.27-12.4,5.5,11.23,4.46-2.18-5.5-11.24Z",
    fill: "#231f20"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 163.03,
    y: 146.99,
    width: 5.97,
    height: 23.5,
    rx: 2.11,
    transform: "translate(384.92 228.28) rotate(153.91)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169.47,170.39a2.5,2.5,0,0,1-.85-.15,2.57,2.57,0,0,1-1.5-1.32l-8.48-17.31a2.62,2.62,0,0,1,1.2-3.49l1.57-.77a2.61,2.61,0,0,1,3.49,1.19l8.48,17.32a2.62,2.62,0,0,1-1.19,3.49l-1.58.77A2.55,2.55,0,0,1,169.47,170.39Zm-6.91-22.31a1.51,1.51,0,0,0-.71.17l-1.57.77h0a1.61,1.61,0,0,0-.82.92,1.64,1.64,0,0,0,.08,1.23L168,168.48a1.61,1.61,0,0,0,.92.82,1.59,1.59,0,0,0,1.23-.08l1.58-.77a1.61,1.61,0,0,0,.73-2.15L164,149A1.59,1.59,0,0,0,162.56,148.08Zm-2.5.49h0Z",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 182.76,
    cy: 192.93,
    r: 15.85,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77,209.29a16.53,16.53,0,0,1-5.31-.89,16.28,16.28,0,0,1-9.39-8.28h0a16.35,16.35,0,0,1,20-22.66,16.2,16.2,0,0,1,9.38,8.28,16.36,16.36,0,0,1-14.67,23.55ZM169,199.68a15.35,15.35,0,1,0,7-20.54,15.24,15.24,0,0,0-7,20.54Z",
    fill: "#231f20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.76,
    cy: 192.93,
    r: 12.88,
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.78,206.3a13.36,13.36,0,1,1,5.86-1.36A13.22,13.22,0,0,1,182.78,206.3Zm0-25.75a12.38,12.38,0,0,0-11.1,17.82h0a12.38,12.38,0,1,0,11.1-17.82Z",
    fill: "#231f20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M166.43,146.59s-.42,8.38,1.69,10.56,11.15,10.77,10.6,12.4-8.16-1.52-8.16-1.52-.33,7,0,8.05-1,3.7-2.44,3.16-6.92-5.88-9-9.47a38.86,38.86,0,0,1-4.19-13.93c-.27-4-1-10.34-1-10.34Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.53,179.81a2,2,0,0,1-.58-.1c-1.58-.59-7.14-6-9.25-9.69a38.87,38.87,0,0,1-4.25-14.15c-.27-4-1-10.25-1-10.31a.51.51,0,0,1,.13-.41.56.56,0,0,1,.4-.15l12.52,1.09a.5.5,0,0,1,.45.52c-.11,2.27,0,8.53,1.56,10.19l1.42,1.42c7.27,7.25,9.71,10.25,9.3,11.49a1.12,1.12,0,0,1-.6.64c-1.47.66-5.74-.88-7.57-1.6a52.73,52.73,0,0,0,0,7.19,3.77,3.77,0,0,1-1.15,3.27A2,2,0,0,1,168.53,179.81Zm-14.05-33.76c.2,1.69.74,6.49,1,9.76a38.43,38.43,0,0,0,4.13,13.71c2.1,3.65,7.44,8.77,8.73,9.25a.88.88,0,0,0,.91-.29,2.88,2.88,0,0,0,.87-2.26c-.34-1.13-.05-7.49,0-8.22a.5.5,0,0,1,.23-.39.47.47,0,0,1,.46,0c2.51,1,6.47,2.3,7.43,1.87.26-1.31-6.7-8.23-9-10.51l-1.43-1.44c-2-2-1.92-8.49-1.85-10.44Z",
    fill: "#231f20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M243.61,148.51v9a21.81,21.81,0,0,0-4,4.73c-1.85,2.94-8.32,13.71-5.33,14.69s9.36-8.81,9.36-8.81l3.26,12.73s5.55-3.26,7.51-8.81,1.14-26.45,1.14-26.45Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M246.87,181.33a.43.43,0,0,1-.19,0,.5.5,0,0,1-.29-.33l-3-11.65c-1.87,2.73-6.52,9-9.31,8.08a1.55,1.55,0,0,1-1-1c-1-2.79,3.9-11,6-14.46a22.26,22.26,0,0,1,4-4.7v-8.75a.49.49,0,0,1,.38-.48l11.91-2.94a.5.5,0,0,1,.43.08.47.47,0,0,1,.19.38c0,.86.8,21.06-1.17,26.63s-7.49,8.95-7.72,9.08A.48.48,0,0,1,246.87,181.33Zm-3.26-13.73h.08a.49.49,0,0,1,.4.37L247.18,180c1.44-1,5.22-3.9,6.73-8.18,1.72-4.87,1.25-22.16,1.14-25.64l-10.94,2.69v8.59a.53.53,0,0,1-.18.39,21.26,21.26,0,0,0-3.93,4.61c-3.43,5.46-6.6,11.77-5.95,13.59a.54.54,0,0,0,.36.36c1.92.64,6.4-4.95,8.78-8.61A.48.48,0,0,1,243.61,167.6Zm0-10.11h0Z",
    fill: "#231f20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M217.38,64.79s31.34,12.41,38.2,28.73,1.92,59.09,1.92,59.09l-19.05.84-9.86-23.22s-36.67,5.05-57.56-2.93l-2,24.33-16-.49s-5.43-12.81-7.51-20.66c-4.24-16.06-3.26-28.8,2.94-44.47S175.27,57,217.38,64.79Z",
    fill: "#FF663B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M225.33,104.4s-3.49,13.93-12.41,20.9-21.33,6.09-26.55,2.39-14.8-14.8-12.84-32.64S225.33,104.4,225.33,104.4Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M197.28,131c-4.65,0-8.76-1.19-11.2-2.92C180.33,124,171.11,112.47,173,95a6.47,6.47,0,0,1,3.5-5.36c11.51-6,47.51,13.5,49,14.34a.48.48,0,0,1,.24.56c-.14.57-3.62,14.17-12.58,21.16A25.92,25.92,0,0,1,197.28,131Zm-15-41.55a11.5,11.5,0,0,0-5.29,1,5.4,5.4,0,0,0-3,4.58c-.88,8,.79,23.8,12.63,32.18,4.91,3.48,17,4.63,26-2.38,7.88-6.14,11.5-18,12.13-20.24C221.46,102.9,195.87,89.47,182.28,89.47Z",
    fill: "#231f20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M211.12,107.3c-5.94,4.31-13.68,4.25-20.61,3.15-5.9-.93-13.77-2.18-17.59-7.17-2.53-3.32-3.62-7.51-4.16-11.64-1-7.33-.79-15.41,2.21-22.28,2.41-5.51,8-8.21,13.2-10.87,12-6.19,27.47-4.13,37.63,4.72,5.3,4.61,8.42,11.4,9.41,18.35s.47,15.86-3,22.21C224.21,111.05,217.57,115,211.12,107.3Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.44,112c-2.57,0-5.06-1.34-7.41-4-4.95,3.41-11.7,4.38-20.6,3-5.9-.93-14-2.2-17.9-7.36-2.23-2.92-3.59-6.69-4.27-11.88-1.16-8.88-.4-16.46,2.26-22.54,2.38-5.45,7.68-8.17,12.81-10.8L184,58c12.09-6.22,27.8-4.25,38.18,4.79,5.09,4.43,8.49,11.06,9.57,18.66,1.2,8.42.05,16.84-3.06,22.52-2.61,4.76-6,7.58-9.45,7.93Q218.82,112,218.44,112Zm-7.32-5.17a.53.53,0,0,1,.38.18c2.43,2.89,5,4.23,7.59,4,3.1-.31,6.26-3,8.67-7.41,3-5.5,4.12-13.69,3-21.9a29.09,29.09,0,0,0-9.24-18c-10.08-8.78-25.33-10.7-37.07-4.66l-.62.32c-5,2.55-10.11,5.19-12.35,10.31-2.58,5.91-3.31,13.31-2.18,22,.66,5,1.95,8.63,4.07,11.4,3.7,4.84,11.54,6.08,17.26,7,8.86,1.4,15.47.4,20.24-3.06A.54.54,0,0,1,211.12,106.8Z",
    fill: "#231f20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M193.72,121.43s-.33,10.45,1.46,11.59,5.39-5.14,5.39-5.14",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M195.67,133.66a1.39,1.39,0,0,1-.75-.21c-1.94-1.24-1.76-10.24-1.71-12a.51.51,0,0,1,.52-.49.5.5,0,0,1,.48.52c-.15,5,.27,10.53,1.24,11.15a.43.43,0,0,0,.38,0c1.22-.3,3.29-3.23,4.31-5a.5.5,0,1,1,.86.5c-.29.51-2.89,5-4.93,5.48A1.9,1.9,0,0,1,195.67,133.66Z",
    fill: "#231f20"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.14,
    cy: 124.13,
    r: 1.43,
    fill: "#231f20"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.41,
    cy: 122.33,
    r: 1.43,
    fill: "#231f20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M228.14,129.83a.51.51,0,0,1-.49-.4.49.49,0,0,1,.39-.59c.08,0,7.87-1.64,10.34-5.64a.49.49,0,0,1,.69-.16.5.5,0,0,1,.16.69c-2.69,4.36-10.65,6-11,6.09Z",
    fill: "#231f20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M167.86,128.11a13,13,0,0,1-8.08-2.53.49.49,0,0,1-.08-.7.51.51,0,0,1,.7-.09c4.33,3.41,10.45,2,10.51,2a.5.5,0,0,1,.23,1A16.48,16.48,0,0,1,167.86,128.11Z",
    fill: "#231f20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M157.23,136.32l-.76,0a.5.5,0,1,1,.06-1c7,.48,13.08-6.45,13.14-6.52a.5.5,0,0,1,.76.65C170.17,129.72,164.39,136.32,157.23,136.32Z",
    fill: "#231f20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M232.34,131a13.3,13.3,0,0,1-3.11-.28.5.5,0,1,1,.25-1c4.54,1.17,20.51-2,20.67-2a.5.5,0,0,1,.59.39.51.51,0,0,1-.4.59C249.79,128.78,238.73,131,232.34,131Z",
    fill: "#231f20"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "190.91 189.94 183.98 195.7 181.01 189.94 173.53 197.11",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53,197.61a.5.5,0,0,1-.35-.86l7.49-7.17a.47.47,0,0,1,.43-.13.5.5,0,0,1,.36.26l2.67,5.21,6.46-5.36a.49.49,0,0,1,.7.06.51.51,0,0,1-.06.71l-6.94,5.76a.5.5,0,0,1-.41.1.49.49,0,0,1-.35-.26l-2.65-5.16-7,6.7A.45.45,0,0,1,173.53,197.61Z",
    fill: "#d1d3d4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 110.04,
    y: 169.62,
    width: 29.29,
    height: 40.65,
    transform: "translate(233.53 389.38) rotate(-175.34)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M137.63,211.89h0l-29.19-2.38a.51.51,0,0,1-.46-.54l3.3-40.52a.51.51,0,0,1,.17-.34.5.5,0,0,1,.37-.11L141,170.37a.5.5,0,0,1,.34.18.48.48,0,0,1,.12.36l-3.3,40.52A.5.5,0,0,1,137.63,211.89ZM109,208.55l28.19,2.3,3.22-39.52L112.2,169Z",
    fill: "#d1d3d4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.9,203.73a11,11,0,0,0,4.36-7.28l-4.81-.39a6.33,6.33,0,0,1-1.57,3.05,6.09,6.09,0,0,1-1.1.93,6.2,6.2,0,0,1-3.27,1.06l-.39,4.82A11.07,11.07,0,0,0,130.9,203.73Z",
    fill: "#d1d3d4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M113.21,194.65a11.05,11.05,0,0,0,2.19,6.79l3.68-3.13a6.27,6.27,0,0,1-1-3.26,6,6,0,0,1,0-.73,5.52,5.52,0,0,1,.1-.71,6.34,6.34,0,0,1,2.67-4,6.27,6.27,0,0,1,3.26-1.05,6,6,0,0,1,.73,0c.24,0,.48.06.71.1a6.24,6.24,0,0,1,3,1.57,6.59,6.59,0,0,1,.94,1.1,6.28,6.28,0,0,1,1.05,3.27l4.82.39a11,11,0,0,0-2.19-6.79,12.15,12.15,0,0,0-.94-1.1,11,11,0,0,0-6.33-3.26l-.72-.08c-.24,0-.49,0-.72,0a11,11,0,0,0-6.79,2.19,9.83,9.83,0,0,0-1.1.93,11,11,0,0,0-3.26,6.34c0,.24-.06.48-.08.72S113.22,194.41,113.21,194.65Z",
    fill: "#d1d3d4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M116.34,202.54a11,11,0,0,0,6.34,3.26l.39-4.82a6.21,6.21,0,0,1-3-1.57Z",
    fill: "#FF663B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 134.77,
    y1: 181.22,
    x2: 116.44,
    y2: 179.73,
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M134.77,181.72h0l-18.33-1.49a.5.5,0,1,1,.08-1l18.33,1.49a.52.52,0,0,1,.46.54A.5.5,0,0,1,134.77,181.72Z",
    fill: "#d1d3d4"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 135.16,
    y1: 176.45,
    x2: 121.85,
    y2: 175.37,
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.16,177h0l-13.31-1.08a.5.5,0,0,1-.45-.54.49.49,0,0,1,.53-.46L135.2,176a.52.52,0,0,1,.46.54A.5.5,0,0,1,135.16,177Z",
    fill: "#d1d3d4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.45,
    cy: 196.14,
    r: 15.05,
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M283.45,211.68A15.55,15.55,0,1,1,299,196.14,15.56,15.56,0,0,1,283.45,211.68Zm0-30.09A14.55,14.55,0,1,0,298,196.14,14.57,14.57,0,0,0,283.45,181.59Z",
    fill: "#d1d3d4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 286.93,
    y: 184.71,
    width: 2.96,
    height: 6.57,
    rx: 1.48,
    transform: "translate(443.54 495.33) rotate(-149.88)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M287.5,191.54a2,2,0,0,1-1.71-3l1.81-3.12a2,2,0,0,1,1.21-.92,1.93,1.93,0,0,1,1.5.2,2,2,0,0,1,.72,2.71l-1.81,3.12A2,2,0,0,1,287.5,191.54Zm1.82-6.09a1,1,0,0,0-.25,0,1,1,0,0,0-.6.46l-1.81,3.12a.94.94,0,0,0-.1.75,1,1,0,0,0,.45.59.94.94,0,0,0,.75.1,1,1,0,0,0,.59-.45l1.82-3.13a1,1,0,0,0-.36-1.34h0A1.05,1.05,0,0,0,289.32,185.45Z",
    fill: "#d1d3d4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.45,
    cy: 196.55,
    r: 9.45,
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M283.43,206.5a10,10,0,0,1-8.58-14.95h0A9.95,9.95,0,1,1,286,206.16,10.25,10.25,0,0,1,283.43,206.5Zm0-18.9a9.16,9.16,0,0,0-2.31.3,8.87,8.87,0,0,0-5.44,4.16h0a8.94,8.94,0,1,0,7.75-4.46Zm-8.18,4.2h0Z",
    fill: "#d1d3d4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.87,
    cy: 195.82,
    r: 7.75,
    fill: "#d1d3d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsEmpty);
export default __webpack_public_path__ + "static/media/statistics_empty.7fd3d20e87d209e3e9f2b07465b65936.svg";
export { ForwardRef as ReactComponent };